import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { IPartner } from 'clickNgo/entities/partner/models'
import { I406Form } from 'clickNgo/models/crud/forms/i406Form'
import { CrudStore } from 'core/types/crudStore'

import { PartnerServiceOptions } from '../configs'
import { map406FromPartner } from '../mapping/map406FromPartner'
import { mapPartnerFrom406Crud } from '../mapping/mapPartnerFrom406Crud'

export const updatePartnersExtRequest = (
  partner: Partial<IPartner>
): Promise<Partial<IPartner>> => {
  const source = CrudStore.get(CrudStoreItem.PartnerAllData, 'update-partners-ext')
  const formattedPartner = map406FromPartner(partner)

  return source
    .update(PartnerServiceOptions.PARTNERS_EXT, [formattedPartner])
    .then(([result]: I406Form[]) => result && mapPartnerFrom406Crud(result))
}
